import { __rest } from "tslib";
import React from 'react';
import Slot from '../slot';
import { isFunction } from '~/utils';
import { usePopoverProvider } from './popover-context';
import { useMergeRefs } from '~/hooks';
const POPOVER_TRIGGER_NAME = 'vulcanui-popover-trigger';
function Trigger(props) {
    const { children } = props, restProps = __rest(props, ["children"]);
    const { getTriggerProps, refs } = usePopoverProvider('PopoverTrigger');
    const ref = useMergeRefs([refs.setReference, isFunction(children) ? null : children.props.ref]);
    const componentProps = Object.assign(Object.assign({}, getTriggerProps(restProps)), { ref });
    if (isFunction(children))
        return children(componentProps);
    return React.createElement(Slot, Object.assign({}, componentProps), children);
}
Trigger.displayName = 'Popover.Trigger';
Trigger.toString = () => `.${POPOVER_TRIGGER_NAME}`;
export default Trigger;
//# sourceMappingURL=popover-trigger.js.map